import { useCallback, useEffect, useState } from 'react';

import { Dimensions, EmitterSubscription, ScaledSize } from 'react-native';

import { useDispatch } from 'react-redux';

import { hidePlayer, setModalPlayerFullscreen } from 'store/player/actions';

import { isPhone, isTablet, isWeb } from 'utils/responsiveness';

import { onAfterHidePlayerModal } from '../utils';

function getOrientationFromDimensions({ width, height }: ScaledSize) {
    return width > height ? 'LANDSCAPE' : 'PORTRAIT';
}

function useCloseModalPlayer() {
    const dispatch = useDispatch();
    const [orientation, setOrientation] = useState<'PORTRAIT' | 'LANDSCAPE'>(
        getOrientationFromDimensions(Dimensions.get('window')),
    );
    const [listenToClose, setListenToClose] = useState(false);

    useEffect(() => {
        let subscription: EmitterSubscription | undefined;

        if (isPhone) {
            subscription = Dimensions.addEventListener(
                'change',
                (dimensions) => {
                    setOrientation(
                        getOrientationFromDimensions(dimensions.window),
                    );
                },
            );
        }

        return () => {
            subscription?.remove();
        };
    }, []);

    useEffect(() => {
        if (listenToClose && orientation === 'PORTRAIT') {
            setListenToClose(false);
            dispatch(hidePlayer());
        }
    }, [orientation]);

    return useCallback(() => {
        if (isPhone && orientation === 'LANDSCAPE') {
            onAfterHidePlayerModal();
            setListenToClose(true);
        } else {
            dispatch(hidePlayer());

            if (isTablet) {
                onAfterHidePlayerModal();
            }

            if (isWeb) {
                dispatch(setModalPlayerFullscreen(false));
            }
        }
    }, [dispatch, orientation]);
}

export default useCloseModalPlayer;
